$(document).ready(function(){
	scrollTo('.repair--delivery-popup');
});

var stores = [];
var selected_store = [];
var slots = [];
var booking_date = '';

var parts = {
	"323294003229":{
		"product":{
			"id":323294003229,
			"title":"Insurance Claim Product",
			"handle":"insruance-claim-product",
			"description":"Insurance Claim Repair",
			"published_at":"2016-11-02T12:55:00+00:00",
			"created_at":"2016-11-02T12:57:39+00:00",
			"vendor":"iSmash",
			"type":"REPAIR",
			"tags":["30 minutes","iphone 6 repairs"],
			"price":0,
			"price_min":0,
			"price_max":0,
			"available":true,
			"price_varies":false,
			"compare_at_price":null,
			"compare_at_price_min":0,
			"compare_at_price_max":0,
			"compare_at_price_varies":false,
			"variants":[{
				"id":32700891466,
				"title":"White",
				"option1":"White",
				"option2":null,
				"option3":null,
				"sku":"",
				"requires_shipping":true,
				"taxable":true,
				"featured_image":null,
				"available":true,
				"name":"Insurance Claim Repair",
				"public_title":"White",
				"options":["White"],
				"price":0,
				"weight":0,
				"compare_at_price":null,
				"inventory_quantity":1,
				"inventory_management":null,
				"inventory_policy":"deny",
				"barcode":""
			}],
			"images":[""],
			"featured_image":"",
			"options":["Colour"],
			"content":""
		},
		"variant":{
			"id":32700891466,
			"title":"White",
			"option1":"White",
			"option2":null,
			"option3":null,
			"sku":"",
			"requires_shipping":true,
			"taxable":true,
			"featured_image":null,
			"available":true,
			"name":"Insurance Claim Repair",
			"public_title":"White",
			"options":["White"],
			"price":0,
			"weight":0,
			"compare_at_price":null,
			"inventory_quantity":1,
			"inventory_management":null,
			"inventory_policy":"deny",
			"barcode":""
		}
	}
};

var booking = {
        first_name: 'Insurance',
        last_name: 'Claim',
        email: null,
        phone: null,
        notes: null,
        address1: 'No Address',
        address2: null,
        city: 'City',
        province: 'Town',
        country: null,
        zip: 'Post Code',
        terms_accepted: false,
        coupon_code: null,
        device_passcode: null,
        imei: null,
        delivery_type: 'store_visit',
        source: null,
        slot: {
            id: null,
            store_id: null,
            day: null,
            start_hour: null,
            start_min: null,
            end_hour: null,
            end_min: null,
            name: "",
            technician_id: null
        },
        model: 'Insurance',
        selectedStore: {
        	store: null
        },
        store_id: null,
        parts: parts,
        confirmed: false,
        confirmation: null,
        callout: null,
        week: moment().week(),
        year: moment().year(),
        stage: 0,
        emailSubmitted: false,
        emailSubmitError: null,
        insurance_reference_number: null,
        booking_date: null,
        optin : false
    };

//Progress Bar
$('.repair--booking-progress-tab').on('click', function(){

	var chosen_step = $(this).data('step');

	if(chosen_step <= booking.stage){
		$('.insurance-step').hide();
		$('#insurance_step' + chosen_step).show();

		$('.repair--booking-progress-tab').removeClass('active');
		$(this).addClass('active');
		booking.stage = chosen_step;

	}
});

var goToStep = function(step){
	var chosen_step = step;

	if(chosen_step <= booking.stage){
		$('.insurance-step').hide();
		$('#insurance_step' + chosen_step).show();

		$('.repair--booking-progress-tab').removeClass('active');
		$('.repair--booking-progress-tab[data-step="'+chosen_step+'"]').addClass('active');
		booking.stage = chosen_step;

	}
}

//Submit insurance details and go to stage 2
$('#insurance-details').submit(function(e){

	e.preventDefault();
	var form = $(this);
	form.parsley().validate();

	if(form.parsley().isValid()){

		booking.stage = 2;
		booking.insurance_reference_number = $('#insurance_reference_number').val();
		booking.emailSubmitted = true;
		booking.email = $('#email').val();
		booking.phone = $('#phone').val();
		var optinval = "No";
		if($('#emailmarketing:checked').val())
			optinval = "Yes";
		booking.optin = optinval;

		$('.insurance-step').hide();
		$('#insurance_step2').show();

		$('.repair--booking-progress-tab').removeClass('active');
		$('.repair--booking-progress-tab[data-step="2"]').addClass('active');
		getStores();
		$('.repair--delivery-method').show();
	}

	scrollTo('.repair--delivery-popup');
});

//Delivery Method Selection
$('.post_in_btn').on('click', function(e){

	e.preventDefault();

	booking.delivery_type = 'insurance_post';

	booking.stage = 3;

	$('.insurance-step').hide();
	$('#insurance_step3').show();

	$('.repair--booking-progress-tab').removeClass('active');
	$('.repair--booking-progress-tab[data-step="3"] div.repair--booking-progress-header').html('Tell us your address');
	$('.repair--booking-progress-tab[data-step="3"]').addClass('active');

	$('.post_in-form').show();
	$('.repair--timetable').hide();

	scrollTo('.repair--delivery-popup');
});

//Submit post in form and go to stage 4
$('#post_in-form').submit(function(e){

	e.preventDefault();
	var form = $(this);
	form.parsley().validate();

	if(form.parsley().isValid()){


		booking.selectedStore.store = {
			"id":30,
			"name":"Insurance",
			"email":"ali@atom42.co.uk",
			"address":"TBC",
			"phone":"+44 (0) 207 640 3115",
			"open_hour":0,
			"open_minute":0,
			"close_hour":0,
			"close_minute":0,
			"lat":51.507406,
			"lng":-0.222634,
			"enabled":1,
			"googleID":"",
			"yelpID":null,
			"store_image":null
		};
		booking.slot = {
			day:6,
			end_hour:20,
			end_min:30,
			id:4330,
			name:"Insurance",
			start_hour:20,
			start_min:00,
			store_id:30,
			technician_id:null
		};

		booking.store_id = 30;

		booking.delivery_type = 'insurance_post';

		booking.first_name = $('#first_name').val();
		booking.last_name = $('#last_name').val();
		booking.address1 = $('#address1').val();
		booking.address2 = $('#address2').val();
		booking.province = $('#town').val();
		booking.city = $('#city').val();
		booking.zip = $('#_postcode').val();
		var optinval = "No";
		if($('#emailmarketing:checked').val())
			optinval = "Yes";
		booking.optin = optinval;

		booking.emailSubmitted = true;

		bookingSummary();

		scrollTo('.repair--delivery-popup');
	}
});

//Store search by postcode
$('#searchPostcode').submit(function(e){
	e.preventDefault();
	gotoNearestStore($('#postcode').val(), stores);

	scrollTo('#searchPostcode');
});


//Get stores as JSON from the API
var getStores = function(){

	$(".repair--store-list").html('');

	var xhr = new XMLHttpRequest();
	xhr.open("GET", "https://api.ismash.com/app/stores", true);
	xhr.onload = function () {
		var data = JSON.parse(xhr.responseText);

		//console.log(data);
		data.forEach(function(store) {
        	if (store.lat && store.address.indexOf("London") > 0) {
	            var storeHTML =  "<li class='col-xs-6' onclick='selectStore(" + JSON.stringify(store) + ")'>" +
	                '<span class="repair--store-title">' +
	                store.name + ' <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>' +
	                '</span>' +
	                '</li>';
				$(".london-stores").append(storeHTML);
			}

			if (store.lat && store.address.indexOf("London") < 0) {
	            var storeHTML2 =  "<li class='col-xs-6' onclick='selectStore(" + JSON.stringify(store) + ")'>" +
	                '<span class="repair--store-title">' +
	                store.name + ' <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>' +
	                '</span>' +
	                '</li>';
				$(".other-stores").append(storeHTML2);
			}
		  });

        stores = data;
        mapInit();
        $('.ajax-spinner').hide();
        $(".store-selection").show();
	};
	xhr.send();

	// $.get( "https://ismash.atom42.co.uk/api/stores", function( data ) {
 //        data.forEach(function(store) {
 //        	if (store.lat && store.in_london) {
	//             var storeHTML =  "<li class='col-xs-6' onclick='selectStore(" + JSON.stringify(store) + ")'>" +
	//                 '<span class="repair--store-title">' +
	//                 store.name + ' <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>' +
	//                 '</span>' +
	//                 '</li>';
	// 			$(".london-stores").append(storeHTML);
	// 		}

	// 		if (store.lat && !store.in_london) {
	//             var storeHTML2 =  "<li class='col-xs-6' onclick='selectStore(" + JSON.stringify(store) + ")'>" +
	//                 '<span class="repair--store-title">' +
	//                 store.name + ' <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>' +
	//                 '</span>' +
	//                 '</li>';
	// 			$(".other-stores").append(storeHTML2);
	// 		}
 // //        });

 //        stores = data;
 //        mapInit();
 //        $('.ajax-spinner').hide();
 //        $(".store-selection").show();
 //    });
}

//Create a marker for each store
var createStoreMarker = function(store) {
    var marker = new google.maps.Marker({
        position: {
            lat: store.lat,
            lng: store.lng
        },
        map: this.map,
        icon: {
            url: "//www.ismash.com/cdn/shop/files/marker2.png?v=5410585011668452327",
        }
    });

    var storeDetailsWrap = document.createElement('div');
    var lineBreak = document.createElement('br');

    var storeDetails = document.createElement('p');

    var storeName = document.createElement('b');
    storeName.textContent = store.name;
    storeDetails.appendChild(storeName);
    storeDetails.appendChild(lineBreak);

    var storeAddress = document.createElement('p');
    storeAddress.textContent = store.address;
    storeDetails.appendChild(storeAddress);
    storeDetails.appendChild(lineBreak);

    var storePhone = document.createElement('p');
    storePhone.textContent = store.phone;
    storeDetails.appendChild(storePhone);
    storeDetails.appendChild(lineBreak);

    var selectStore = document.createElement('a');
    selectStore.classList.add('btn');
    selectStore.href = 'javascript:selectStore('+ JSON.stringify(store) +')';
    selectStore.textContent = "Select this store";
    storeDetails.appendChild(selectStore);

    storeDetailsWrap.appendChild(storeDetails);

    var infoWindow = new google.maps.InfoWindow({
        content: storeDetailsWrap
    });
    google.maps.event.addListener(infoWindow, 'closeclick', function() {
        self.map.setZoom(6);
        self.map.setCenter({
            lat: 52.7040556,
            lng: -1.6913345
        });
    });

    var self = this;
    marker.addListener('click', (function(self, infoWindow, marker) {
        return function() {
            self.map.setZoom(15);
            self.map.setCenter(marker.getPosition());
            infoWindow.open(self.map, marker);
        };
    })(self, infoWindow, marker));
    return marker;
}

//Initialise the Google Map
var mapInit =  function(){
	var self = this;
    var mapEl = document.querySelector('[data-map]');
    if (!mapEl) {return;}
    self.map = new google.maps.Map(mapEl, {
        center: {
            lat: 52.7040556,
            lng: -1.6913345
        },
        zoom: 6
    });

    for (var i = 0; i < stores.length; i++) {
        var store = stores[i];
        if (!store.lat || !store.lng) {
            continue;
        }
        createStoreMarker(store);
    }
}

//Get the user postcode and go to nearest store
var gotoNearestStore = function(postcode, stores){
	if (!postcode) {
        mapInit(stores);
        return;
    }

    $.get('https://maps.googleapis.com/maps/api/geocode/json?address=' + postcode + ', GB').then(function(data) {
        var userLocation = data.results[0].geometry.location;
        userLocation = new google.maps.LatLng(userLocation.lat, userLocation.lng);

        var nearestStore = null;
        var nearestStoreDistance = null;

        for (var i = 0; i < stores.length; i++) {
            var storeLocation = new google.maps.LatLng(stores[i].lat, stores[i].lng);
            var currentStoreDistance = google.maps.geometry.spherical.computeDistanceBetween(userLocation, storeLocation);

            if (!nearestStoreDistance || currentStoreDistance < nearestStoreDistance) {
                nearestStore = stores[i];
                nearestStoreDistance = currentStoreDistance;
            }
        }

        var marker = createStoreMarker(nearestStore);
        map.setZoom(15);
        map.setCenter(marker.getPosition());
    }, function(data) {
        console.error(data);
    });
}

//Select store and go to stage 3
var selectStore = function(store){

	booking.store_id = store.id;
	booking.slot.store_id = store.id;
	booking.selectedStore.store = store;
	booking.storename = store.name;
	booking.storeemail = store.email;
	booking.storeaddress = store.address

	booking.slot.day = null;
	booking.slot.start_hour = null;
	booking.slot.start_min = null;
	booking.slot.end_hour = null;
	booking.slot.end_min = null;

	booking.delivery_type = 'store_visit';

	$('.timetable-day').removeClass('active');
	$('.slots').html('');
    $('.slots').hide();
	$('#confirmSlot').hide();

	$('.insurance-step').hide();
	$('#insurance_step3').show();

	$('.repair--booking-progress-tab').removeClass('active');
	$('.repair--booking-progress-tab[data-step="3"]').addClass('active');
	$('.repair--booking-progress-tab[data-step="3"] div.repair--booking-progress-header').html('Select Date & Time');

	$('.post_in-form').hide();
	$('#selected_store_name').html(store.name);
	$('#selected_store_address').html(store.address);
	$('.repair--timetable').show();

	booking.stage = 3;
	getDaySlots();
	scrollTo('.repair--delivery-popup');
}

//Get day slots from the API
var getDaySlots = function(){
	$.get( 'https://api.ismash.com/app/store/' + booking.selectedStore.store.id + '/slots/' + booking.year + '/' + booking.week, function( data ) {
		slots = data;
		renderDaySlots();
	});
}

//Function to go to next week. Reset slot details
var getNextWeek = function(){
	booking.week = booking.week + 1;

	booking.slot.day = null;
	booking.slot.start_hour = null;
	booking.slot.start_min = null;
	booking.slot.end_hour = null;
	booking.slot.end_min = null;

	$('.timetable-day').removeClass('active');
	$('.slots').html('');
    $('.slots').hide();
	$('#confirmSlot').hide();

	getDaySlots();
}

//Function to go to previous week. Reset slot details
var getPrevWeek = function(){
	booking.week = booking.week - 1;

	booking.slot.day = null;
	booking.slot.start_hour = null;
	booking.slot.start_min = null;
	booking.slot.end_hour = null;
	booking.slot.end_min = null;

	$('.timetable-day').removeClass('active');
	$('.slots').html('');
    $('.slots').hide();
	$('#confirmSlot').hide();

	getDaySlots();
}

//Function to find available day slots
var availableDaySlots = function(){
	var daySlots = [
        [],
        [],
        [],
        [],
        [],
        [],
        []
    ];

	for (var i = 0; i < slots.length; i++) {
        if (!daySlots[slots[i].day]) {
            daySlots[slots[i].day] = [];
        }

        daySlots[slots[i].day].push(slots[i]);
    }

    return daySlots;
}

//Render the days
var renderDaySlots = function(){
	$('.timetable').html('');
	var daySlots = availableDaySlots();
    var dates = [];
    for (var i = 0; i < daySlots.length; i++) {
        dates.push(moment().year(booking.year).week(booking.week).day(i).format("dddd Do MMMM"));
    }

    for (var i = 0; i < dates.length; i++){
    	var disabled = '';
    	if(daySlots[i] == '')
    		disabled = 'class="disabled"';
    	var daySlot = '<div class="timetable-day" id="timetable-day'+i+'"';
    		if(!disabled)
    			daySlot += ' onclick="selectDay('+i+')"';
    		daySlot += '>';
    		daySlot += '<div '+disabled+'>';
    		daySlot += '<div class="day">' + dates[i].split(' ')[0] + '</div>';
    		daySlot += '<div class="date">' + dates[i].split(' ')[1] + '</div>';
    		daySlot += '<div class="month">' + dates[i].split(' ')[2] + '</div>';
    		daySlot += '</div>';
    		daySlot += '</div>';
    		daySlot += '<div id="mobile_slots'+i+'" class="mobile-slots"></div>';

    	$('.timetable').append(daySlot);
    }
}

//Select a day from the day slot and display it's time slots
var selectDay = function(day) {

	booking.slot.day = day;

	$('.timetable-day').removeClass('active');
	$('.desktop #timetable-day'+day).addClass('active');
	$('.mobile #timetable-day'+day).addClass('active');
	//scrollTo('.mobile #timetable-day'+day);

	var availibleDaySlots = availableDaySlots();
    var daySlots = JSON.parse(JSON.stringify(availibleDaySlots));

    for (var i = 0; i < daySlots.length; i++) {
        if (!daySlots[i]) {
            continue;
        }
        var thisDaysSlots = daySlots[i].map(function(e) {
            return {
                start_hour: e.start_hour,
                start_min: e.start_min
            };
        });

        var openHour = 6;
        var openMin = 0;
        var closeHour = 22;
        var closeMin = 0;

        var start = moment().utc().hours(openHour).minutes(openMin).tz('Europe/London');
        var end = moment().utc().hours(closeHour).minutes(closeMin).tz('Europe/London');

        var current = start;
        while (current < end) {

            var thisSlot = {
                start_hour: current.hours(),
                start_min: current.minutes()
            };

            if (!findObjInArray(thisDaysSlots, thisSlot)) {
                daySlots[i].push({
                    id: -1,
                    start_hour: current.hours(),
                    start_min: current.minutes(),
                    end_hour: current.hours(),
                    end_min: current.minutes(),
                    disabled: true
                });
            }

            current = current.add(30, 'minutes');
        }

        daySlots[i] = daySlots[i].sort(function(a, b) {
            var aInMins = (a.start_hour * 60) + a.start_min;
            var bInMins = (b.start_hour * 60) + b.start_min;
            if (aInMins > bInMins) {
                return 1;
            }
            return -1;
        });


    }
    $('.slots').html('');
    $('.slot').removeClass('active');
    $('.slots').show();
    $('#confirmSlot').hide();
    $('.mobile-slots').html('');
    for(var i=0; i < daySlots[day].length; i++){
    	var start_hour = daySlots[day][i]['start_hour'];
    	var start_min = daySlots[day][i]['start_min'];
    	var slot_id = daySlots[day][i]['id'];

    	var disabled = '';
    	if(daySlots[day][i]['id'] < 0)
    		disabled = ' disabled';

    	var date = moment().year(booking.year).week(booking.week).day(booking.slot.day);
    	date.utc().hour(start_hour).utc().minute(start_min);

    	var slot_time = date.tz('Europe/London').format("HH:mm")

    	var slot_el = '<div class="slot'+disabled+'" id="slot'+slot_id+'"';
    	if(!disabled)
    		slot_el += ' onclick="selectSlot('+start_hour+','+start_min+','+slot_id+')"';
    	slot_el += '>'+slot_time+'</div>';



    	$('.mobile #mobile_slots'+day).append(slot_el);


    	$('.slots').append(slot_el);
    }

    $('.mobile #mobile_slots'+day).append('<button class="cta confirmSlot" type="button"  onclick="bookingSummary()"> Confirm </button>');
}

//Select available timeslot from the table
var selectSlot = function(start_hour, start_min, slot_id){

	booking.slot.id = slot_id;

	booking.slot.start_hour = start_hour;
	booking.slot.start_min = start_min;

	if(start_min == 30){
		booking.slot.end_hour = start_hour + 1;
		booking.slot.end_min = 0;
	}else{
		booking.slot.end_hour = start_hour;
		booking.slot.end_min = 30;
	}



	$('.slot').removeClass('active');
	$('.desktop #slot'+slot_id).addClass('active');
	$('.mobile #slot'+slot_id).addClass('active');

	scrollTo('.mobile .confirmSlot', 100);

	var date = moment().year(booking.year).week(booking.week).day(booking.slot.day);
    date.utc().hour(booking.slot.start_hour).utc().minute(booking.slot.start_min);

    booking_date = date.tz('Europe/London').format("dddd Do MMMM [at] HH:mm");
    $('.confirmSlot').show().html('Confirm ' + booking_date);

    booking.booking_date = booking_date;
}

//Booking Summary
var bookingSummary = function(){

	scrollTo('.repair--delivery-popup');

	booking.stage = 4;

	$('#booking_summary').html('');
	$('.insurance-step').hide();
	$('#insurance_step4').show();
	$('.repair--booking-progress-tab').removeClass('active');
	$('.repair--booking-progress-tab[data-step="4"]').addClass('active');

	if(booking.delivery_type == 'store_visit'){

		var summary ='<h2>Appointment Summary</h2>';
			summary += '<p>Please confirm the following details and book your appointment</p>';

			summary += '<h3>Your Details</h3>';

			summary += '<ul>';
				summary += '<li><b>Insurance Reference Number:</b> ' + booking.insurance_reference_number + '</li>';
				summary += '<li><b>Email Address:</b> ' + booking.email + '</li>';
				summary += '<li><b>Phone Number:</b> ' + booking.phone + '</li>';
			summary += '</ul>';

			summary += '<h3>Appointment Details</h3>';

			summary += '<ul>';
				summary += '<li><b>Store Name:</b> ' + booking.selectedStore.store.name + '</li>';
				summary += '<li><b>Store Address:</b> ' + booking.selectedStore.store.address + '</li>';
				summary += '<li><b>Booking Date:</b> ' + booking_date + '</li>';
			summary += '</ul>';

	}else if(booking.delivery_type == 'insurance_post'){



		var summary ='<h2>Summary</h2>';
			summary += '<p>Please confirm your details to receive your pack</p>';

			summary += '<h3>Your Details</h3>';

			summary += '<ul>';
				summary += '<li><b>Insurance Reference Number:</b> ' + booking.insurance_reference_number + '</li>';
				summary += '<li><b>Name: </b>' + booking.first_name + ' ' + booking.last_name + '</li>';
				summary += '<li><b>Email Address:</b> ' + booking.email + '</li>';
				summary += '<li><b>Phone Number:</b> ' + booking.phone + '</li>';
			summary += '</ul>';

			summary += '<h3>Your Address</h3>';

			summary += '<p>';
				if(booking.address1)
					summary += booking.address1;
				if(booking.address2)
					summary += ', ' + booking.address2;
				if(booking.province)
					summary += ', ' + booking.province;
				if(booking.city)
					summary += ', ' + booking.city;
				if(booking.zip)
					summary += ', ' + booking.zip;
			summary += '</p>';

		$('#confirm_booking_cta').html('Post me my pack');

		var whn_summary = '<h3>What happens next?</h3>';
			whn_summary += '<ul>';
				whn_summary += '<li>You will receive a priority pack in which to send your broken device to us</li>';
				whn_summary += '<li>Simply follow the instructions included and return the pack as soon as possible</li>';
				whn_summary += '<li>We aim to assess, repair and dispatch your device back to you within 2 working days</li>';
				whn_summary += '<li>In the event of any issues, we will contact you to discuss the matter</li>';
			whn_summary += '</ul>';

	}

	$('#booking_summary').html(summary);

	$('#what_happens_next').html(whn_summary);
}

//Booking confirmation
var confirmBooking = function(){

	booking.terms_accepted = true;

	if(booking.week > 52){
		booking.week = booking.week - 52;
		booking.year = booking.year + 1;
	}

	booking.booking_date = booking_date;

	//console.log(booking);

	newbooking = {
		"email" : booking.email,
		"phone" : booking.phone,
		"first_name" : booking.first_name,
		"last_name" : booking.last_name,
		"address1" : booking.address1,
		"address2" : booking.address2,
		"province" : booking.province,
		"city" : booking.city,
		"zip" : booking.zip,
		"store" : booking.storename,
		"store_email" : booking.storeemail,
		"store_address" : booking.storeaddress,
		"booking_date" : booking.booking_date,
		"insurance_reference_number" : booking.insurance_reference_number,
		"optin" : booking.optin
	};

	$.post( "https://api.ismash.com/app/booking/insurance", newbooking).done(function( data ) {
		// console.log(data);
        window.location.href = "/pages/insurance-repair-confirmed#" + encodeURIComponent(JSON.stringify(newbooking));
	});
}

//Helper Function: Find object in an array
var findObjInArray = function(array, obj) {
    for (var i = 0; i < array.length; i++) {
        var found = true;
        for (var x = 0; x < Object.keys(obj).length; x++) {
            var attr = Object.keys(obj)[x];
            var value = obj[Object.keys(obj)[x]];
            if (array[i][attr] !== value) {
                found = false;
            }
        }
        if (!found) {
            continue;
        }
        return true;
    }
    return false;
}

//Helper Function: create CORS request to prevent Shopify Error
var createCORSRequest = function(method, url) {
    var xhr = new XMLHttpRequest();
    if ("withCredentials" in xhr) {
        xhr.open(method, url, true);
    } else if (typeof XDomainRequest != "undefined") {
        xhr = new XDomainRequest();
        xhr.open(method, url);
    } else {
        xhr = null;

    }
        return xhr;
}

//Helper Function: scroll to element
var scrollTo = function (selector, offset) {
    if (!offset) {
        offset = 80;
    }
    Vue.nextTick(function() {
        $('html, body').animate({
            scrollTop: $(selector).offset().top - offset
        }, 1000);
    });
}
